import { render, staticRenderFns } from "./shareFrom.vue?vue&type=template&id=213d4084&scoped=true&"
import script from "./shareFrom.vue?vue&type=script&lang=js&"
export * from "./shareFrom.vue?vue&type=script&lang=js&"
import style0 from "./shareFrom.vue?vue&type=style&index=0&id=213d4084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d4084",
  null
  
)

export default component.exports